import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoiseControlOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"noise_control_off"}/>
}
